import { ODataSearchDirective } from '@absg/angular-components';
import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: '[nc-clear-search-input]',
    templateUrl: './clear-search-input.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ClearSearchInputComponent {
  @Input() odataSearch: ODataSearchDirective;
  @Input() searchTextField: ElementRef; // if you pass the element ref from the component
  @Input() inputField: HTMLInputElement; // if you pass the html ref directly
  @Output() clearSearch = new EventEmitter();

  clearSearchText(): void {
    this.clearSearch.emit();
    if (this.odataSearch !== undefined) {
      this.odataSearch.inputChange('');
    }

    const nativeElement = this.inputField ?? this.searchTextField.nativeElement as HTMLInputElement;

    nativeElement.focus();
    nativeElement.value = '';
  }
}
